module.exports = __webpack_public_path__ + "img/applet.d693a9af.png";